var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('resource-menu'),_c('kdw-Statusbar-card',{ref:"kdwsnackbar"}),_c('common-view'),_c('common-footer'),_c('kdw-Cookiebar-card',{model:{value:(_vm.cookieUpdate),callback:function ($$v) {_vm.cookieUpdate=$$v},expression:"cookieUpdate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }